import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Episodes from './pages/Episodes';
import Contact from './pages/Contact';
import JesseMission from './pages/JesseMission';
import JoshMission from './pages/JoshMission';
import './App.css';
import './styles/footer.css';
import './styles/header.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/episodes" element={<Episodes />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/jesse-mission" element={<JesseMission />} />
            <Route path="/josh-mission" element={<JoshMission />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;